import { render, staticRenderFns } from "./DataDestructionActs.vue?vue&type=template&id=0d36aa1e&scoped=true&"
import script from "./DataDestructionActs.vue?vue&type=script&lang=js&"
export * from "./DataDestructionActs.vue?vue&type=script&lang=js&"
import style0 from "./DataDestructionActs.vue?vue&type=style&index=0&id=0d36aa1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d36aa1e",
  null
  
)

export default component.exports